import { useState } from 'react';

const parseFilter = (val) => (val !== null && val !== void 0 ? val : '').split(':').map(str => str.trim());
const incrementIndex = (index, length) => {
    if (index < 0)
        return length - 1;
    else if (index >= length)
        return 0;
    else
        return index;
};
const useKeyboardListNavigation = () => {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const resetIndex = () => setSelectedIndex(-1);
    const handleArrowDown = listLength => {
        const newIndex = incrementIndex(selectedIndex + 1, listLength);
        setSelectedIndex(newIndex);
    };
    const handleArrowUp = listLength => {
        const newIndex = incrementIndex(selectedIndex - 1, listLength);
        setSelectedIndex(newIndex);
    };
    return {
        handleArrowDown,
        handleArrowUp,
        resetIndex,
        selectedIndex,
    };
};

export { incrementIndex, parseFilter, useKeyboardListNavigation };
